<div data-cy="edit-contact-dialog">
  <div class="tw-flex tw-justify-between tw-items-center">
    <h2
      class="mb-0"
      mat-dialog-title>
      Manage Business Personnel
    </h2>
    <mat-icon
      mat-dialog-close
      (click)="close()"
      data-cy="close-contact-dialog">
      close
    </mat-icon>
  </div>

  <mat-dialog-content>
    <a id="topDialog"></a>
    <app-alert
      *ngFor="let alert of allAlerts$ | async"
      [message]="alert.message"
      [level]="alert.level"
      [dismissDelay]="5000"
      (fired)="scrollToTop()"
      (dismissed)="dismissAlert(alert)">
    </app-alert>
    <!-- Creating owners and non-owners -->
    <app-add-personnel-smart
      [nonOwnerPersonnel]="(newNonOwnerPersonnel$ | async)"
      [contact]="(newContact$ | async)"
      [borrowerId]="data.borrowerId">
    </app-add-personnel-smart>
    <!-- Display and edit existing non-owners (ie: nonOwnerPersonnel) -->
    <app-edit-non-owner-personnel-smart
      *ngFor="let nonOwnerPersonnel of nonOwnerPersonnel$ | async"
      [nonOwnerPersonnel]="nonOwnerPersonnel">
    </app-edit-non-owner-personnel-smart>
    <!-- Display and edit existing owners (ie: contacts) -->
    <app-edit-contact-smart
      *ngFor="let contact of existingContacts$ | async"
      [contact]="contact"
      [borrowerId]="data.borrowerId">
    </app-edit-contact-smart>
    <div class="add-personnel">
      <button
        mat-button
        color="primary"
        (click)="addPersonnel()"
        data-cy="edit-contact-dialog-add-personnel-button">
        + Add Personnel
      </button>
    </div>
  </mat-dialog-content>
</div>
